import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import {
  getVendorLevelInformationReducedByVendorNumber,
  getVendorLevelInformationReducedByVendorName
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";

class LookupVendorLevelInformation extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false,
    routeArr: "",
    route: ""
  };
  constructor(props) {
    super(props);
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
    this.setRoute();
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (
      this.state.lookup &&
      (this.state.lookup.vendor || this.state.lookup.vendName)
    ) {
      var item =
        this.state.endPoint === getVendorLevelInformationReducedByVendorName
          ? this.state.lookup.vendName.replace(" ", "%20")
          : this.state.lookup.vendor;
      this.state.endPoint(item).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        var data = [];

        if (res.data.success) {
          data = res.data.data;
        } else {
          data = false;
          this.setErrorMessage("Nothing found.");
        }
        this.setState({ data });
        this.setState({
          header: [
            {
              label: "Vendor",
              value: data === false ? "" : data[0].vendor,
              name: "vendor"
            },
            {
              label: "Vendor Name",
              value: data === false ? "" : data[0].vendName,
              name: "vendName"
            }
          ],
          cards: [
            {
              card3: [
                { label: "Vendor", name: "Vendor" },
                { label: "AP Vendor", name: "APVendor" },
                { label: "Master Vendor", name: "MasterVendor" },
                { label: "Name", name: "Name" },
                { label: "OR", name: "OR" },
                { label: "SH", name: "SH" },
                { label: "PM", name: "PM" },
                {
                  name: "[0].vendor",
                  label: data === false ? "." : data[0].vendor
                },
                {
                  name: "[0].apRefNo",
                  label: data === false ? "." : data[0].apRefNo
                },
                {
                  name: "[0].masterVendor",
                  label: data === false ? "." : data[0].masterVendor
                },
                {
                  name: "[0].vendName",
                  label: data === false ? "." : data[0].vendName
                },
                {
                  name: "[0].orderMethod",
                  label: data === false ? "." : data[0].orderMethod
                },
                {
                  name: "[0].shipMethod",
                  label: data === false ? "." : data[0].shipMethod
                },
                {
                  name: "[0].designatedPM",
                  label: data === false ? "." : data[0].designatedPM
                },
                {
                  name: "[1].vendor",
                  label: data === false ? "." : data[1].vendor
                },
                {
                  name: "[1].apRefNo",
                  label: data === false ? "." : data[1].apRefNo
                },
                {
                  name: "[1].masterVendor",
                  label: data === false ? "." : data[1].masterVendor
                },
                {
                  name: "[1].vendName",
                  label: data === false ? "." : data[1].vendName
                },
                {
                  name: "[1].orderMethod",
                  label: data === false ? "." : data[1].orderMethod
                },
                {
                  name: "[1].shipMethod",
                  label: data === false ? "." : data[1].shipMethod
                },
                {
                  name: "[1].designatedPM",
                  label: data === false ? "." : data[1].designatedPM
                },
                {
                  name: "[2].vendor",
                  label: data === false ? "." : data[2].vendor
                },
                {
                  name: "[2].apRefNo",
                  label: data === false ? "." : data[2].apRefNo
                },
                {
                  name: "[2].masterVendor",
                  label: data === false ? "." : data[2].masterVendor
                },
                {
                  name: "[2].vendName",
                  label: data === false ? "." : data[2].vendName
                },
                {
                  name: "[2].orderMethod",
                  label: data === false ? "." : data[2].orderMethod
                },
                {
                  name: "[2].shipMethod",
                  label: data === false ? "." : data[2].shipMethod
                },
                {
                  name: "[2].designatedPM",
                  label: data === false ? "." : data[2].designatedPM
                },
                {
                  name: "[3].vendor",
                  label: data === false ? "." : data[3].vendor
                },
                {
                  name: "[3].apRefNo",
                  label: data === false ? "." : data[3].apRefNo
                },
                {
                  name: "[3].masterVendor",
                  label: data === false ? "." : data[3].masterVendor
                },
                {
                  name: "[3].vendName",
                  label: data === false ? "." : data[3].vendName
                },
                {
                  name: "[3].orderMethod",
                  label: data === false ? "." : data[3].orderMethod
                },
                {
                  name: "[3].shipMethod",
                  label: data === false ? "." : data[3].shipMethod
                },
                {
                  name: "[3].designatedPM",
                  label: data === false ? "." : data[3].designatedPM
                },
                {
                  name: "[4].vendor",
                  label: data === false ? "." : data[4].vendor
                },
                {
                  name: "[4].apRefNo",
                  label: data === false ? "." : data[4].apRefNo
                },
                {
                  name: "[4].masterVendor",
                  label: data === false ? "." : data[4].masterVendor
                },
                {
                  name: "[4].vendName",
                  label: data === false ? "." : data[4].vendName
                },
                {
                  name: "[4].orderMethod",
                  label: data === false ? "." : data[4].orderMethod
                },
                {
                  name: "[4].shipMethod",
                  label: data === false ? "." : data[4].shipMethod
                },
                {
                  name: "[4].designatedPM",
                  label: data === false ? "." : data[4].designatedPM
                }
              ]
            }
          ]
        });
        this.state.lookup.vendor = data === false ? "." : data[0].vendor;
        this.state.lookup.vendName = data === false ? "." : data[0].vendName;
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please input your query");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        vendor: value.header.vendor,
        vendName: value.header.vendName
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
    }
  };

  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }
  componentDidUpdate() {
    if (
      this.props.location.pathname.split("_")[
        this.props.location.pathname.split("_").length - 1
      ] !== this.state.component
    ) {
      this.setRoute();
    }
  }
  setRoute = () => {
    this.setState({
      component: this.props.location.pathname.split("_")[
        this.props.location.pathname.split("_").length - 1
      ]
    });
  };
  capitalize = val => {
    const valCapitalized = val.charAt(0).toUpperCase() + val.slice(1);
    return valCapitalized;
  };
  selectEndPoint = x => {
    x === "vendor"
      ? this.setState({
          endPoint: getVendorLevelInformationReducedByVendorNumber
        })
      : this.setState({
          endPoint: getVendorLevelInformationReducedByVendorName
        });
  };
  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Vendor-Level Information by{" "}
          {this.capitalize(this.state.component ? this.state.component : "")}
        </h3>
        <HeaderLayout
          location={this.state.component}
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          selectEndPoint={this.selectEndPoint}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
          checkOrderConstraints={this.checkOrderConstraints}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Link to="/" className="sub-menu-item-tag">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
            </Link>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}
export default LookupVendorLevelInformation;
